
import { lazy, Suspense } from "react"
const SearchPageContent = lazy(() => import ("../components/SearchPageComponents/SearchPageContent"))
function Search({ data }) {
    return (
        <Suspense fallback={<div></div>}>
        <SearchPageContent 
        data={data} 
        showFilter={true}
        title={'Alla Montrar'}
        notFoundTitle={'Hittade ej några montrar'}
        />
        </Suspense>
    )
}

export default Search
